import React from 'react'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useBranch } from 'hooks/useBranch'
import { Card, CardContent } from 'design-system'
import { AlertTriangle } from 'lucide-react'
import BranchSwitcher from 'Components/Common/BranchSwitcher'

interface ViewModeGuardProps {
 allowedModes: ('global' | 'branch')[]
 children: React.ReactNode
}

export const ViewModeGuard: React.FC<ViewModeGuardProps> = ({ allowedModes, children }) => {
 const { t } = useTranslation()
 const { viewMode } = useBranch()

 if (allowedModes.includes(viewMode)) {
 return <>{children}</>
 }

 if (viewMode === 'global' && !allowedModes.includes('global')) {
 return (
 <div className="flex items-center justify-center min-h-[50vh]">
 <Card className="max-w-md w-full">
 <CardContent className="p-8 text-center">
 <AlertTriangle className="h-12 w-12 mx-auto text-amber-500 mb-4"/>
 <h3 className="text-lg font-semibold mb-2">{t('common.security.branchRequired')}</h3>
 <p className="text-muted-foreground">{t('common.security.selectBranchHint')}</p>
 <div className="mt-6 flex justify-center" data-testid="view-mode-guard-branch-switcher">
  <BranchSwitcher />
 </div>
 </CardContent>
 </Card>
 </div>
 )
 }

 return <Navigate to="/"replace />
}
